import React, { useEffect, useMemo, createContext, useContext, useState } from 'react';
import PropTypes from 'prop-types';

import posthog from 'posthog-js';

import { AuthContext } from 'components/providers/AuthContextProvider';
import { ConfigContext } from 'components/providers/ConfigContextProvider';

const PostHogContext = createContext();

const PostHogProvider = ({ children }) => {
  const { authUser } = useContext(AuthContext);
  const { posthog_token, posthog_host } = useContext(ConfigContext);

  const [initialized, setInitialized] = useState(false);

  useEffect(() => {
    const initializePostHog = () => {
      if (authUser && posthog_token && !initialized) {
        posthog.init(posthog_token, {
          api_host: posthog_host || 'https://us.i.posthog.com',
          autocapture: false,
          capture_pageview: false,
          capture_pageleave: false,
          capture_performance: false,
        });
        if (authUser.id) {
          posthog.identify(authUser.id, {
            email: authUser.email,
            name: authUser.name,
          });
        }

        setInitialized(true);
      }
    };

    initializePostHog();
  }, [authUser, posthog_token, posthog_host, initialized]);

  const posthogInstance = useMemo(() => {
    return initialized ? posthog : { capture: () => {} };
  }, [initialized]);

  return <PostHogContext.Provider value={posthogInstance}>{children}</PostHogContext.Provider>;
};

PostHogProvider.propTypes = {
  children: PropTypes.any,
};

const usePostHog = () => {
  const context = useContext(PostHogContext);
  if (!context) {
    throw new Error('usePostHog must be used within a PostHogProvider');
  }
  return context;
};

export { PostHogProvider };
export default usePostHog;
